export default __webpack_public_path__ + "static/media/planning.72cffd31.png";